
import { Component, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import { UserModule } from '@/store/modules/user';
import { checkCertificate } from '@/api/business';
import { getUserInfo } from '@/api/user';

@Component({
  name: 'LoginIndex',
})
export default class extends Vue {
  private loginForm = {
    username: '',
    password: '',
  };

  private rules = {
    username: [{ required: true, message: '아이디를 입력하세요.', trigger: 'blur' }],
    password: [{ required: true, message: '비밀번호를 입력하세요.', trigger: 'blur' }],
  }

  private loading: boolean = false;

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.loading = true;
        UserModule.Login(this.loginForm).then(async () => {
          this.loading = false;
          await UserModule.GetUserInfo();
          await getUserInfo().then((res) => {
            if (res.data && res.data.withdrawStatus === true) {
              this.$message.error('탈퇴한 계정입니다. 관리자에게 문의해주세요.');
              UserModule.LogOut();
            } else if ([1, 2, 3].includes(UserModule.industry)) {
              checkCertificate().then((res2) => {
                if (res2.data.joinStatus && !res2.data.certificateStatus) {
                  this.$message.warning('정산을 위해 공인인증서 등록절차를 진행해주세요 ');
                  this.$router.push({ name: 'Certificate' });
                } else if (!res2.data.joinStatus) {
                  this.$alert('정산을 위해 사업장주소, 담당자 이름, 정산 담당자 연락처, 담당자 이메일을 입력해주세요, ');
                  this.$router.push({ name: 'Business' });
                } else {
                  this.$router.push({ name: 'Business' });
                }
              }).catch(() => {
                this.$router.push({ name: 'Business' });
              });
            } else {
              this.$router.push({ name: 'Business' });
            }
          });
        }).catch(() => {
          this.loading = false;
        });
      }
    });
  }

  private removeSpaceFormData() {
    this.loginForm.username = this.loginForm.username.replace(/(\s*)/g, '');
    this.loginForm.password = this.loginForm.password.replace(/(\s*)/g, '');
  }

  private bannerClick() {
    this.$message.warning('로그인 후 이용 가능합니다..');
  }
}
